class UploadFeedback extends HTMLElement {
  connectedCallback () {
    this.input = this.querySelector('input[type="file"]')
    this.mainText = this.querySelector('#upload-text-main')
    this.subText = this.querySelector('#upload-text-sub')
    this.label = this.querySelector('label')
    this.form = this.closest('form')
    this.submitBtn = this.form ? this.form.querySelector('button[type="submit"], input[type="submit"]') : null

    // Disable submit button initially
    if (this.submitBtn && (!this.input.files || this.input.files.length === 0)) {
      this.submitBtn.disabled = true
      this.submitBtn.classList.add('opacity-50', 'cursor-not-allowed')
    }

    if (this.input) {
      this.input.addEventListener('change', this.updateText.bind(this))
    }

    if (this.label) {
      this.label.addEventListener('dragover', (e) => {
        e.preventDefault()
        this.label.classList.add('bg-[#ebfcf5]')
      })
      this.label.addEventListener('dragleave', (e) => {
        e.preventDefault()
        this.label.classList.remove('bg-[#ebfcf5]')
      })
      this.label.addEventListener('drop', (e) => {
        e.preventDefault()
        this.label.classList.remove('bg-[#ebfcf5]')
        if (e.dataTransfer && e.dataTransfer.files.length > 0) {
          const dtFiles = e.dataTransfer.files
          if (dtFiles.length > 5) {
            alert('Maximum 5 files allowed.')
            return
          }
          if (Array.from(dtFiles).some(f => f.type !== 'application/pdf' && !f.name.toLowerCase().endsWith('.pdf'))) {
            alert('Only PDF files are allowed.')
            return
          }
          this.input.files = dtFiles
          this.updateText()
        }
      })
    }

    if (this.form) {
      this.form.addEventListener('submit', () => {
        if (this.submitBtn) {
          this.submitBtn.disabled = true
          if (this.submitBtn.tagName === 'INPUT') {
            this.submitBtn.value = 'Uploading...'
          } else {
            this.submitBtn.innerHTML = 'Uploading <span class="loading loading-spinner loading-xs ml-2"></span>'
          }
          this.submitBtn.classList.remove('opacity-50', 'cursor-not-allowed')
          this.submitBtn.classList.add('opacity-70', 'cursor-wait')
        }
      })
    }
  }

  updateText () {
    const files = this.input.files
    if (files && files.length > 0) {
      if (files.length > 5) {
        alert('Maximum 5 files allowed.')
        this.input.value = ''
        return this.updateText()
      }
      if (Array.from(files).some(f => f.type !== 'application/pdf' && !f.name.toLowerCase().endsWith('.pdf'))) {
        alert('Only PDF files are allowed.')
        this.input.value = ''
        return this.updateText()
      }

      if (files.length === 1) {
        this.mainText.textContent = files[0].name
      } else {
        this.mainText.textContent = `${files.length} files selected`
      }
      this.subText.textContent = 'Click to change files'

      // Enable submit button
      if (this.submitBtn) {
        this.submitBtn.disabled = false
        this.submitBtn.classList.remove('opacity-50', 'cursor-not-allowed')
      }
    } else {
      this.mainText.textContent = 'Drag & drop your PDF here'
      this.subText.textContent = 'or click to browse'

      // Disable submit button
      if (this.submitBtn) {
        this.submitBtn.disabled = true
        this.submitBtn.classList.add('opacity-50', 'cursor-not-allowed')
      }
    }
  }
}
if (!window.customElements.get('upload-feedback')) {
  window.customElements.define('upload-feedback', UploadFeedback)
}
